





































































import { Vue, Component, Ref  } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { SaveEmbalagemUseCase } from '@/usecases'
import CamposDeEndereco from '../ui/CamposDeEndereco.vue'
import { obrigatorio } from '@/shareds/regras-de-form'
import { Embalagem } from '@/models/Embalagem'
import { Loja } from '@/models'
import ListaDeCategorias from './ListaDeCategorias.vue'

@Component({
	components: {
		CamposDeEndereco,
		ListaDeCategorias,
	},
})
export default class DialogoDeEdicaoDeEmbalagem extends Vue {
	@Ref() form!: HTMLFormElement
	embalagem: Embalagem | null = null
	mostra = false
	salvando = false
	lojas: Loja[] = []

	obrigatorio = obrigatorio

	saveEmbalagemUseCase = new SaveEmbalagemUseCase()

	mostrar(embalagemAtual: Embalagem) {
		const embalagemObj = new Object() as Embalagem

		embalagemObj.id = embalagemAtual.id
		embalagemObj.nome = embalagemAtual.nome
		embalagemObj.loja = embalagemAtual.loja
		embalagemObj.comprimento = embalagemAtual.comprimento
		embalagemObj.peso = embalagemAtual.peso
		embalagemObj.largura = embalagemAtual.largura
		embalagemObj.altura = embalagemAtual.altura
		embalagemObj.categorias = embalagemAtual.categorias

		this.embalagem = embalagemObj
		this.mostra = true
	}

	esconder() {
		this.mostra = false
		this.embalagem = null
	}

	async salvar() {
		this.form.validate()
		if (!this.embalagem) return
		if (!this.form.validate()) return

		try {
			this.salvando = true

			if (!this.embalagem.id) {
				this.embalagem = await this.saveEmbalagemUseCase.criar(this.embalagem)
			} else {
				this.embalagem = await this.saveEmbalagemUseCase.editar(this.embalagem)
			}

			this.$emit('atualizar')
			
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.mostra = false
			this.salvando = false
			this.embalagem = null
		}
	}
}
